/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_0_AnswerInputs */

const en_gc_search_guides_gridcraft_online_sections_7_questions_0_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_0_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No desktop installation is needed for the browser editor. The browser still needs to load the application files before the workspace starts.`)
};

const zh_gc_search_guides_gridcraft_online_sections_7_questions_0_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_0_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器编辑器无需安装桌面应用，但在启动工作区前，浏览器仍需要加载应用文件。`)
};

/**
* | output |
* | --- |
* | "No desktop installation is needed for the browser editor. The browser still needs to load the application files before the workspace starts." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_0_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_7_questions_0_answer = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_0_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_0_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_7_questions_0_answer(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_7_questions_0_answer(inputs)
});
export { gc_search_guides_gridcraft_online_sections_7_questions_0_answer as "gc.search_guides.gridcraft_online.sections.7.questions.0.answer" }